import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'

import { BONUS_TYPE_MESSAGES } from 'helpers/i18n.jsx'
import {
    BATTLE_TYPE_RESERVE_DESCRIPTION,
    BATTLE_TYPE_RESERVE_DURATION_DESCRIPTION,
    RESERVE_TYPE_CONDITION,
} from './translations'

import styles from './SingleValueBonusDescription.scss'

export const SingleValueBonusDescription = ({
    layoutType = 'default',
    battleType,
    reserveType,
    bonusType,
    reserveParameters,
}) => {
    const { bonus, duration } = reserveParameters

    return (
        <p className={cx(styles.base, styles[`base__${layoutType}Layout`])}>
            <span className={cx(styles.value, bonus.isHighlightEnabled && styles.value__glow)}>
                <span className={styles.sign}>{'+'}</span>
                <span className={styles.number}>{bonus.value}</span>
                <span className={styles.percent}>{'%'}</span>
            </span>
            &ensp;
            <span className={styles.description}>
                <span className={styles.target}>
                    {BONUS_TYPE_MESSAGES[bonusType]}
                    {RESERVE_TYPE_CONDITION[reserveType] && (
                        <span>
                            &thinsp;
                            {RESERVE_TYPE_CONDITION[reserveType]}
                        </span>
                    )}
                </span>
                <br/>
                {duration ?
                    BATTLE_TYPE_RESERVE_DURATION_DESCRIPTION[battleType](duration, bonusType) :
                    BATTLE_TYPE_RESERVE_DESCRIPTION[battleType]
                }
            </span>
        </p>
    )
}

const reserveParameterPropTypes = PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    isHighlightEnabled: PropTypes.bool,
})

SingleValueBonusDescription.propTypes = {
    reserveParameters: PropTypes.shape({
        bonus: reserveParameterPropTypes.isRequired,
        duration: reserveParameterPropTypes,
    }),
    reserveType: PropTypes.string.isRequired,
    battleType: PropTypes.string.isRequired,
    bonusType: PropTypes.string.isRequired,
    layoutType: PropTypes.oneOf(['default', 'tooltip', 'toolbar']),
}



// WEBPACK FOOTER //
// ./components/ReserveBonus/components/SingleValueBonusDescription/SingleValueBonusDescription.jsx